export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props?: Partial<{
    className: string;
    id: string;
    text: string;
    html: string;
    attrs: Record<string, string | number | boolean>;
    on: Partial<Record<keyof HTMLElementEventMap, EventListener>>;
    style: Partial<CSSStyleDeclaration>;
  }>,
  children?: Array<Node | string | null | undefined>,
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (props?.className) el.className = props.className;
  if (props?.id) el.id = props.id;
  if (props?.text != null) el.textContent = props.text;
  if (props?.html != null) el.innerHTML = props.html;
  if (props?.attrs) {
    for (const [k, v] of Object.entries(props.attrs)) {
      if (v === false || v == null) continue;
      el.setAttribute(k, v === true ? '' : String(v));
    }
  }
  if (props?.on) {
    for (const [k, fn] of Object.entries(props.on)) {
      if (fn) el.addEventListener(k, fn as EventListener);
    }
  }
  if (props?.style) Object.assign(el.style, props.style);
  if (children) {
    for (const c of children) {
      if (c == null) continue;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
  }
  return el;
}

export function clear(el: HTMLElement): void {
  while (el.firstChild) el.removeChild(el.firstChild);
}
